import { mediaUrl } from "@/lib/api";

export const UserAvatar = ({ user, size = 32, testId = "user-avatar" }) => {
  const initial = (user?.name || user?.email || "?").trim().charAt(0).toUpperCase();
  const style = { width: size, height: size, fontSize: Math.round(size * 0.42) };
  return user?.avatar_url ? (
    <img src={mediaUrl(user.avatar_url)} alt={user?.name || "Photo de profil"} style={style}
      className="rounded-full object-cover ring-2 ring-white shadow-sm shrink-0" data-testid={testId} />
  ) : (
    <span style={style} className="rounded-full bg-[#1877f2] text-white font-bold grid place-items-center ring-2 ring-white shadow-sm shrink-0" data-testid={testId}>
      {initial}
    </span>
  );
};
